import type { MessageType } from './Message';

/**
 * Figma `5-Message 消息提示` 的状态图标。
 * 这些 Symbol 已进入本地 Iconfont（2026-09-17 包交付），组件直接渲染本地 `Icon`。
 */
export const messageIconNames: Record<MessageType, string> = {
  danger: 'circle-close-filled',
  info: 'info-filled',
  primary: 'info-filled',
  success: 'circle-check-filled',
  warning: 'warning-filled',
};

export const messageCloseIconName = 'close';

export const messagePlaceholderGlyphs: Record<MessageType, string> = {
  danger: '×',
  info: 'i',
  primary: 'i',
  success: '✓',
  warning: '!',
};
